import { render, staticRenderFns } from "./TextAnime.vue?vue&type=template&id=60c13aba&scoped=true"
import script from "./TextAnime.vue?vue&type=script&lang=js"
export * from "./TextAnime.vue?vue&type=script&lang=js"
import style0 from "./TextAnime.vue?vue&type=style&index=0&id=60c13aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c13aba",
  null
  
)

export default component.exports